import { Component, OnInit } from '@angular/core';
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {DialogModel} from "@shared/models/dialog.model";
import {FormBuilder, Validators} from "@angular/forms";

@Component({
    standalone: false,
    selector: 'particle-mx-hallmark-report-export-input-dialog',
  templateUrl: './mx-hallmark-report-export-input-dialog.component.html',
  styleUrls: ['./mx-hallmark-report-export-input-dialog.component.scss']
})
export class MxHallmarkReportExportInputDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  refTitle1: string;
  refValue1: string;
  refTitle2: string;
  refValue2: string;
  inputForm: any;
  constructor(private formBuilder: FormBuilder) {
    this.inputForm = this.formBuilder.group({
      formReferenceTitle1: ['Mexico MDR'],
      formReferenceValue1: ['Esquemas Reportables']
    });
  }

  ngOnInit() {
  }
  onOkClicked(): boolean {
    this.data.input['exportReportInfo'] = this.inputForm.value;
    return true;
  }

}
